import {fetch, put} from '@/base-http'
import Widget from '@/modules/widget/model/Widget'

/**
 * Proporciona la lista de widgets del usuario actual
 */
export async function getWidgets () {
    const data = await fetch('prologue/dashboard/widgets')
    if (!Array.isArray(data)) {
        throw new Error(`La lista de widgets deber ser un array pero se obtuvo ${typeof data}`)
    }

    return data.map(w => Widget.deserialize(w))
}

/**
 * Actualiza la lista de widgets registrados para el usuario actual
 * @param widgets
 */
export async function updateLayout (widgets: Widget[]) {
    const data = await put('prologue/dashboard/widgets', widgets.map(w => w.serialize()))
    if (!Array.isArray(data)) {
        throw new Error(`La lista de widgets deber ser un array pero se obtuvo ${typeof data}`)
    }

    return data.map(w => Widget.deserialize(w))
}

/**
 * Actualiza el estado de un widget
 *
 * @param id
 * @param state
 */
export async function updateWidgetState (id: number, state: any) {
    const data = await put(`prologue/dashboard/widget/${id}`, { state })

    return Widget.deserialize(data)
}
